import type { i18n as I18n } from "i18next";
import en from "@/locales/en/games/mine-field.json";
import fr from "@/locales/fr/games/mine-field.json";

export const MINE_FIELD_NS = "games/mine-field";

/** Adds this game's translations to an initialised i18next instance (idempotent). */
export function registerMineFieldTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", MINE_FIELD_NS))
    i18n.addResourceBundle("en", MINE_FIELD_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", MINE_FIELD_NS))
    i18n.addResourceBundle("fr", MINE_FIELD_NS, fr, true, true);
}
